import { GetCurrentQuery } from 'generated/resources/graphql'

import type Employee from '../store/models/Employee'
import hasRegularAccess from './hasRegularAccess'

interface Props {
  employee: Employee
  canCreateEmployees: boolean
  currentEmployee: GetCurrentQuery['apiCore']['currentsConnection']['edges'][number]['node']['employee']
}

export const hideAccessBannerForEmployee = ({
  employee,
  canCreateEmployees,
  currentEmployee,
}: Props) => {
  if (!canCreateEmployees || employee.isTerminated) {
    return true
  }

  if (!currentEmployee?.hasRegularAccess) {
    return true
  }

  return !hasRegularAccess(employee.attributes.has_regular_access)
}
